import { Controller } from "stimulus"

// Sorts table rows when a header is clicked, within each tbody independently.
// Rows marked data-sort-skip stay put (group headers); rows marked
// data-sort-footer stay at the bottom of their tbody (total rows).
// Cells can provide data-sort-value (e.g. ISO dates) — otherwise text is used,
// compared numerically when both values parse as numbers.
export default class extends Controller {
  static targets = ["header"]

  sort(event) {
    const header = event.currentTarget
    const index = [...header.parentNode.children].indexOf(header)
    const direction = header.dataset.direction === "asc" ? "desc" : "asc"

    this.headerTargets.forEach(h => {
      delete h.dataset.direction
      h.querySelector(".sort-indicator")?.remove()
    })
    header.dataset.direction = direction
    header.insertAdjacentHTML("beforeend", `<span class="sort-indicator">${direction === "asc" ? " ▲" : " ▼"}</span>`)

    const value = row => {
      const cell = row.children[index]
      if (!cell) return ""
      return cell.dataset.sortValue ?? cell.textContent.trim()
    }
    const compare = (a, b) => {
      const av = value(a)
      const bv = value(b)
      const an = parseFloat(av.replace(/[$,]/g, ""))
      const bn = parseFloat(bv.replace(/[$,]/g, ""))
      const result = (!isNaN(an) && !isNaN(bn)) ? an - bn : av.localeCompare(bv)
      return direction === "asc" ? result : -result
    }

    this.element.querySelectorAll("tbody").forEach(tbody => {
      const rows = [...tbody.children]
      const footer = rows.find(row => "sortFooter" in row.dataset)
      const dataRows = rows.filter(row => !("sortSkip" in row.dataset) && !("sortFooter" in row.dataset))

      dataRows.sort(compare).forEach(row => {
        footer ? tbody.insertBefore(row, footer) : tbody.appendChild(row)
      })
    })
  }
}
